export default {
  title: 'Richiedi eliminazione dati per {{name}}',
  description:
    "Crea una richiesta GDPR di cancellazione dati. Un amministratore deve approvarla prima dell'eliminazione definitiva dei dati del cliente.",
  form: {
    note: {
      label: 'Nota',
      placeholder: 'Aggiungi contesto per questa richiesta (facoltativo)',
    },
  },
  buttons: {
    confirm: 'Richiedi eliminazione',
  },
  toasts: {
    success: 'Richiesta di eliminazione dati creata',
    error: 'Creazione richiesta di eliminazione dati non riuscita',
  },
};
